
import React from "react";
import { i18nManager } from "../../i18n";
import styles from "../../assets/style.module.css";
import { editionDates, indexTag } from "../../helpers";
import { ITournament, TournamentStatus } from "../../../../../services";

export function statusLabel(status?: string) {
    const labels = i18nManager.Labels.tournaments;
    if (status === TournamentStatus.ONGOING) return labels.live;
    if (status === TournamentStatus.UPCOMING) return labels.upcoming;
    return labels.past;
}

export interface TournamentCardProps {
    index: number;
    tournament: ITournament;
    onSelect: (t: ITournament) => void;
}

function TournamentCard({ index, tournament: t, onSelect }: TournamentCardProps) {

    const edition = t.tournament_edition;
    const tags = [
        statusLabel(edition?.status),
        edition?.participant_members_count ? `${edition.participant_members_count}v${edition.participant_members_count}` : undefined,
        edition?.location,
    ].filter(Boolean) as string[];

    return (<button className={styles["work-card"]} onClick={() => onSelect(t)}>
        <span className={styles["work-img"]}>
            {(edition?.banner_url || edition?.logo_url) ? (<img src={edition.banner_url || edition.logo_url} alt={t.name} loading="lazy" />) : (<span className={styles["img-ph"]} />)}
            <span className={styles["work-float"]}>
                {tags.map((tag) => (<span key={tag} className={styles["chip"]}>{tag}</span>))}
            </span>
            <span className={styles["work-view"]}>{i18nManager.Labels.view}</span>
        </span>
        <span className={styles["work-text"]}>
            <span className={styles["work-name"]}>
                {t.name}
                {editionDates(edition) && (<small>{editionDates(edition)}</small>)}
            </span>
            <span className={styles["work-index"]}>{indexTag(index)}</span>
        </span>
    </button>);
}

export default TournamentCard;
